export default "assets/images/background-b3c551b5.jpg";